import { useController, UseControllerProps, FieldValues } from 'react-hook-form';

export type YesNoFieldProps<T extends FieldValues> = UseControllerProps<T> & {
  onChange?: () => void;
  disabled?: boolean;
};

export const YesNoField = <T extends FieldValues>(props: YesNoFieldProps<T>) => {
  const { field } = useController(props);

  const { value, onChange: fieldOnChange, name, onBlur } = field;
  const { disabled = false } = props;

  const handleYesClick = () => {
    fieldOnChange(true);
    props.onChange?.();
  };

  const handleNoClick = () => {
    fieldOnChange(false);
    props.onChange?.();
  };

  return (
    <div className="align-self-center w-md-100 d-flex">
      <div className="form-check form-check-custom form-check-solid form-check-secondary form-check-inline d-flex align-items-center">
        <input
          className="form-check-input"
          type="radio"
          name={name}
          checked={value === true}
          onChange={handleYesClick}
          onBlur={onBlur}
          disabled={disabled}
        />
        <label className="ms-2">Yes</label>
      </div>
      <div className="form-check form-check-custom form-check-solid form-check-secondary form-check-inline d-flex align-items-center">
        <input
          className="form-check-input"
          type="radio"
          name={name}
          checked={value === false}
          onChange={handleNoClick}
          onBlur={onBlur}
          disabled={disabled}
        />
        <label className="ms-2">No</label>
      </div>
    </div>
  );
};
